const getters = {
  token: state => state.user.token,
  accountType: state => state.user.accountType,
  accountId: state => state.user.accountId,
  userName: state => state.user.userName,
}

export default getters
